{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ChevronsDownIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ChevronsDownIcon = React.forwardRef<SVGSVGElement, ChevronsDownIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 91 99"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M45.4294 89.0373C49.7395 83.5897 53.604 78.742 57.4357 73.8654C63.7103 65.8785 69.8405 57.7719 76.2864 49.9274C78.9741 46.6568 82.2998 43.9049 85.3833 40.9678C86.7071 39.7063 88.4109 38.6049 90.0065 40.1007C91.7786 41.7606 90.6629 43.5722 89.2846 44.9577C74.4514 59.8625 64.2741 78.3141 51.3705 94.6891C47.5677 99.5145 44.3654 100.143 39.6608 96.0575C38.1526 94.7928 36.7389 93.4196 35.4308 91.9489C26.2532 81.2604 16.9876 70.6421 8.06665 59.7423C5.20239 56.2434 3.23017 51.9976 1.00124 48.0084C0.621879 47.3284 0.775416 45.5366 1.08521 45.4303C2.22264 45.0365 3.88641 44.6052 4.71077 45.1526C7.95308 47.3073 11.3608 49.4549 13.9593 52.2896C20.2312 59.1333 26.0667 66.3753 32.111 73.429C35.6657 77.577 39.2913 81.6653 42.8663 85.7963C43.6467 86.7001 44.3523 87.6728 45.4294 89.0373Z" fill={color}/>
<path d="M45.4294 49.6574C49.7395 44.2098 53.604 39.3621 57.4357 34.4856C63.7103 26.4986 69.8405 18.392 76.2864 10.5475C78.9741 7.27696 82.2998 4.52502 85.3833 1.58791C86.7071 0.326427 88.4109 -0.774937 90.0065 0.720856C91.7786 2.38073 90.6629 4.19232 89.2846 5.57785C74.4514 20.4826 64.2741 38.9343 51.3705 55.3092C47.5677 60.1346 44.3654 60.7634 39.6608 56.6777C38.1526 55.4129 36.7389 54.0397 35.4308 52.569C26.2532 41.8805 16.9876 31.2622 8.06665 20.3624C5.20239 16.8635 3.23017 12.6177 1.00124 8.62848C0.621879 7.94851 0.775416 6.15672 1.08521 6.0504C2.22264 5.65659 3.88641 5.22532 4.71077 5.7727C7.95308 7.92746 11.3608 10.075 13.9593 12.9097C20.2312 19.7534 26.0667 26.9954 32.111 34.0491C35.6657 38.1971 39.2913 42.2855 42.8663 46.4165C43.6467 47.3202 44.3523 48.2929 45.4294 49.6574Z" fill={color}/>

      </svg>
    )
  }
)

ChevronsDownIcon.displayName = 'ChevronsDownIcon'
